import BasePage from "../modules/basePage";

class DefaultPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
    }
}

new DefaultPage();
